import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'

import { Korttisuodatus } from '../../../_jaettu-lemonator/model/tyolistan-yhteenvetokortit'

@Component({
  selector: 'app-korttisuodatuksen-indikaattori',
  templateUrl: './korttisuodatuksen-indikaattori.component.html',
  styleUrls: ['./korttisuodatuksen-indikaattori.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KorttisuodatuksenIndikaattoriComponent {
  readonly suodatus = input.required<Korttisuodatus>()
  readonly asiakkaita = input.required<number>()

  readonly poista = output<void>()
}
